import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { translator } from 'mage-i18n';

import { SplitImageContainer } from './SplitImageContainer';
import { AOSplitImageContainer } from './AOSplitImageContainer';
import { MerchantPortalContainer } from './MerchantPortalContainer';

import { isNewSplitLayout } from '@/selectors/merchant';
import { IS_ONBOARDING_APP } from '../constants';
import { isUnmanagedKyc } from '../selectors/widget';
import { isKustomPartner } from '@/selectors/data';

const { type: env } = window.config?.common?.environment || {};
const IS_MOET_GUI =
  ['development', 'staging'].includes(env) && window.location.pathname?.startsWith('/products/gui');

const ContainerTemplate = props => {
  const ref = useRef(null);
  const {
    // scrolls to top of the container on every render when true
    scrollIntoView = false,
    isNewSplitLayout,
    isUnmanagedKyc,
    isKustomPartner,
  } = props;

  useEffect(() => {
    if (scrollIntoView && ref.current) {
      ref.current.scrollIntoView({ behaviour: 'smooth' });
    }
  });

  const determineContainer = () => {
    if (isKustomPartner || IS_MOET_GUI || (!IS_ONBOARDING_APP && !isUnmanagedKyc)) {
      return isNewSplitLayout ? SplitImageContainer : MerchantPortalContainer;
    }
    return isNewSplitLayout ? AOSplitImageContainer : MerchantPortalContainer;
  };

  const Container = determineContainer();

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }}
      ref={ref}
    >
      {/* This form tag is added to allow submitting steps using the enter key, which triggers the
       call to action button instead of having to click next. For that to work, we need to override
       the default behaviour of the form and execute our own logic only. */}
      <Container {...props} />
    </form>
  );
};

ContainerTemplate.propTypes = {
  isNewSplitLayout: PropTypes.bool.isRequired,
  isUnmanagedKyc: PropTypes.bool.isRequired,
  children: PropTypes.node,
  contentWidth: PropTypes.number,
  error: PropTypes.object,
  info: PropTypes.string,
  isKustomPartner: PropTypes.bool,
  merchant: PropTypes.object,
  scrollIntoView: PropTypes.bool,
  showRecaptchaFooter: PropTypes.bool,
  subtitle: PropTypes.node,
  t: PropTypes.func,
  tFrontEndError: PropTypes.string,
  title: PropTypes.string,
};

export default connect(state => ({
  isNewSplitLayout: isNewSplitLayout(state),
  isUnmanagedKyc: isUnmanagedKyc(state),
  isKustomPartner: isKustomPartner(state),
  t: translator(state),
}))(ContainerTemplate);
